import axios from '@/api/axios'

const getAllGroupsTrainers = () => {
  return axios.get(`/groupsTrainers`)
}

const getGroupsTrainers = (groupId) => {
  return axios.get(`/groupsTrainers?groupId=${groupId}`)
}

const addGroupsTrainers = (trainer) => {
  return axios.post(`/groupsTrainers`, trainer)
}

const deleteGroupsTrainers = (id) => {
  return axios.delete(`/groupsTrainers/${id}`)
}

export default {
  getAllGroupsTrainers,
  getGroupsTrainers,
  addGroupsTrainers,
  deleteGroupsTrainers,
}
